import BaseBehavior from '../../../framework/base/base';

export default class SiblingMenu extends BaseBehavior {
	constructor(element) {
		super(element);
		this.addEventListener(this.element, 'click', event => {
			let { target } = event;
			while (event.currentTarget !== target) {
				if (target.nodeName === 'LABEL') {
					const input = document.getElementById(target.getAttribute('for'));
					if (input && input.checked) {
						input.checked = false;
						event.preventDefault();
					}
					return;
				}
				target = target.parentNode;
			}
		});
	}

	cleanup() {
		this.removeEventListener(this.element, 'click');
	}
}
